import ThumbFont from './thumbFont';

export default class ThumbSvg extends ThumbFont {
  constructor (parameters) {
    super();
    this.width = 122.5;
    this.height = 76;
    this.content = null;
    this.thumb = null;
    this.id = null;

    this.setValues(parameters);
    this.uuid = Base64.encode(this.thumb).replace(/([^a-z0-9]+)/gi, '');
  }

  getItem () {
    const $container = this.getItemContainer();
    const $a = $container.find('a');
    setRightSizeThumbBackground(INKIVE.Helpers.getCORSSecureUrl('https://static.inkive.com/' + this.thumb));

    return $container;

    function setRightSizeThumbBackground (url) {
      setThumbBackground(url, 100);

      const thumb = new Image();
      thumb.src = url;
      thumb.onload = function () {
        const containerRatio = $a.width() / $a.height();
        const imageRatio = this.width / this.height;

        const difference = imageRatio / containerRatio;
        imageRatio > containerRatio && setThumbBackground(url, difference * 100);
      };
    }

    function setThumbBackground (url, percentage) {
      $a.css('background', 'url(' + url + ') 50% 50% no-repeat')
        .css('background-size', percentage + '%');
    }
  }

  _addElement (x, y) {
    const editor = INKIVE.Tool.getInstance().editor;
    const canvas = editor.canvas;

    const stickerGraphic = INKIVE.Helpers.getStickerFromString(this.content);

    editor.canvas.getCurrentDrawing().getCurrentLayer().appendChild(stickerGraphic);

    INKIVE.Helpers.resize(stickerGraphic, canvas.contentW, canvas.contentH, x, y);

    editor.canvas.selectOnly([stickerGraphic]);

    INKIVE.Tool.blinkScreen(stickerGraphic);
  }

  onItemClick (item, event) {
    const editor = INKIVE.Tool.getInstance().editor;
    const canvas = editor.canvas;

    const bb = item.getBoundingClientRect();
    const x = (canvas.contentW - bb.width) / 2;
    const y = (canvas.contentH - bb.height) / 2;

    const isReplace = $(event.target).closest('[data-type=replace-sticker]').length;

    isReplace || this._addElement(x, y);
    isReplace && this._replaceElement();
  }

  onItemRelease (item) {
    const editor = INKIVE.Tool.getInstance().editor;

    const bb = this.getItemContainer().get(0).getBoundingClientRect();
    const zoom = INKIVE.EditorFacade.handle('zoom', 'get');
    const offset = editor.getOffset();

    const x = Math.floor4((bb.left - offset.x) / zoom);
    const y = Math.floor4((bb.top - offset.y) / zoom);

    this._addElement(x, y);
  }

  _replaceElement (item) {
    const editor = INKIVE.Tool.getInstance().editor;
    const canvas = editor.canvas;

    const selectedElements = canvas.getSelectedElems();
    const $selectedElement = selectedElements.length === 1 ? $(selectedElements[0]) : null;

    if ($selectedElement && $selectedElement.is('.sticker, .icon, .logo') && $selectedElement.is('.element')) {
      const bbox = $selectedElement[0].getBBox();
      const size = Math.max(bbox.width, bbox.height);
      const bboxData = {
        size: {
          width: size,
          height: size
        },
        position: {
          x: bbox.x,
          y: bbox.y
        },
        selected: true
      };
      const data = _.extend({
        content: this.content,
        thumb_src: INKIVE.C.STATIC_URL + this.thumb
      }, bboxData);

      INKIVE.DesignFacade.handle($selectedElement.attr('id'), 'delete');
      INKIVE.DesignFacade.create('sticker', data);
    }
  }
}
